<template>
  <el-card>
    <el-collapse :value="['1', '2']">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title">机械基础信息</div>
        </template>
        <el-form ref="form" class="global-form2" :model="formData" :rules="rules" label-position="right"
          label-width="100px">
          <el-form-item prop="machineryName" label="机械名称">
            <el-input v-model="formData.machineryName" placeholder="请输入机械名称" maxlength="50" />
          </el-form-item>
          <el-form-item prop="specificationModel" label="规格/型号">
            <el-input v-model="formData.specificationModel" placeholder="请输入规格型号" maxlength="50" />
          </el-form-item>
          <el-form-item prop="unitPrice" label="单价(元)">
            <el-input v-model="formData.unitPrice" placeholder="请输入单价" maxlength="50" />
          </el-form-item>
          <el-form-item label="所属供应商" prop="supplierId">
            <el-select v-model="formData.supplierId" filterable clearable placeholder="请选择所属供应商">
              <el-option v-for="item in supplierData" :key="item.supplierId" :label="item.supplierName"
                :value="item.supplierId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否含油" prop="whetherOil">
            <el-radio-group v-model="formData.whetherOil">
              <el-radio border v-for="(item, index) in oilList" :key="index" :label="item.dicCode">{{ item.dicValue
                }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title">资质证书</div>
        </template>
        <el-form class="global-form2" :model="formData" label-position="right" :rules="rules" label-width="100px">
          <el-form-item prop="driveFileList" label="驾驶许可证">
            <custom-upload v-model="formData.driveFileList" :limit="1"></custom-upload>
          </el-form-item>
          <el-form-item prop="envirFileList" label="环保证书">
            <custom-upload v-model="formData.envirFileList" :limit="1"></custom-upload>
          </el-form-item>
          <el-form-item prop="otherFileList">
            <template slot="label">其他材料<br>(最多6张)</template>
            <custom-upload v-model="formData.otherFileList"></custom-upload>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <div class="mt20">
      <el-button type="primary" @click="submit">保存</el-button>
      <el-button @click="$router.back()">取消</el-button>
    </div>
  </el-card>
</template>

<script>
import { phone, idCardNo, pInteger } from '@/utils/validate'
export default {
  name: 'MachineAdd',
  data () {
    return {
      formData: {
        machineryName: '', // 机械名称
        specificationModel: '', // 规格/型号
        supplierId: '', // 所属供应商
        unitPrice: '',
        whetherOil: '2', // 是否含油
        driveFileList: [], // 驾驶许可证
        envirFileList: [], // 环保证书
        otherFileList: [] // 其他材料
      },

      supplierData: [],
      oilList: [],

      rules: {
        machineryName: [
          { required: true, message: '请输入机械名称', trigger: 'blur' }
        ],
        specificationModel: [
          { required: true, message: '请输入规格型号', trigger: 'blur' }
        ],
        unitPrice: [
          { required: true, message: '请输入单价', trigger: 'blur' },
          { validator: pInteger }
        ],
        driverLicenseNum: [
          { validator: idCardNo }
        ],
        driverMobile: [
          { validator: phone }
        ]
      }
    }
  },
  computed: {

    machineryId () {
      return this.$route.query.machineryId
    },

    normalProjectList () {
      return this.$store.state.projectList
    }
  },

  created () {
    if (this.machineryId) {
      this.loadData()
    }
    this.loadSupplierType()
    this.getOilList()
  },
  methods: {
    loadData () {
      this.$axios.get(this.$apis.material.selectYhMachineryByMachineryId, {
        machineryId: this.machineryId
      }).then(res => {
        this.formData = res || {}
      })
    },

    // 是否含油
    getOilList () {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'whetherOil' }).then(res => {
        this.oilList = res.whetherOil || []
      })
    },

    loadSupplierType () {
      this.$axios.get(this.$apis.material.selectYhSupplierByPage).then(res => {
        this.supplierData = res.list
      })
    },

    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.formData.project === '') {
            this.formData.project = null
          }
          // 编辑去除字段
          delete this.formData.whetherOilName
          const url = this.machineryId ? this.$apis.material.updateYhMachinery : this.$apis.material.insertYhMachinery
          this.$axios.post(url, this.formData).then(() => {
            this.$router.back()
          })
        }
      })
    }
  }

}
</script>

<style scoped lang="scss">
.collapse-title {
  position: relative;
  width: auto;
  height: 24px;
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  line-height: 24px;
  padding-left: 8px;

  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 6px;
    width: 2px;
    height: 12px;
    background: #3592FE;
  }

  .el-tooltip {
    color: #cccccc;
  }
}

.widthlimit {
  width: 360px;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0;
}
</style>
